var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, functionType="function", escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  
  return "\n          <span class=\"c-media-list-item__content__meta__premium-label\">\n            プレミアム記事\n          </span>\n        ";
  }

function program3(depth0,data) {
  
  
  return "\n          <img class=\"p-article-info__sponsor-label\" src=\"//cdn.mamari.jp/static/mamariQ/img/common/sponsor-label.png\">\n        ";
  }

  buffer += "<li class=\"c-media-list__item\">\n  <a class=\"c-media-list__item__link js-show-content\" data-content-type=\"TrendNews\" href=\"http://mamari.jp/"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.Article)),stack1 == null || stack1 === false ? stack1 : stack1.id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "?utm_source=mamariq_app&utm_medium=find_content_trend\">\n    <img class=\"c-media-list-item__thumb\" src=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.Article)),stack1 == null || stack1 === false ? stack1 : stack1.image_url)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" alt=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.Article)),stack1 == null || stack1 === false ? stack1 : stack1.og_title)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">\n    <p class=\"c-media-list-item__content\">\n      <span class=\"c-media-list-item__content__title\">"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.Article)),stack1 == null || stack1 === false ? stack1 : stack1.og_title)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</span>\n      <span class=\"c-media-list-item__content__meta\">\n        ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.Article)),stack1 == null || stack1 === false ? stack1 : stack1.is_premium), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        "
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.MamariUser)),stack1 == null || stack1 === false ? stack1 : stack1.name)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\n        ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.Article)),stack1 == null || stack1 === false ? stack1 : stack1.is_sponsored), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </span>\n    </p>\n  </a>\n</li>\n";
  return buffer;
  });


//////////////////
// WEBPACK FOOTER
// ./webroot/hbs/trend_article.hbs
// module id = 226
// module chunks = 0